import { offlinePoints } from "@/mocks/homeData";

export default function OfflineGuide() {
  return (
    <section id="offline" className="w-full bg-foreground-950 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-wide text-accent-300 md:text-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            离线观看
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            缓存完成之后，没有网络也能接着追
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-50/70 md:mt-4 md:text-base">
            离线观看是缓存视频的结果。只要剧集已经保存到手机本地，即使关掉网络或处在信号很弱的地方，也能打开播放，不依赖实时加载。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-12 md:gap-5">
          {offlinePoints.map((point) => (
            <div
              key={point.title}
              className="rounded-lg border border-background-50/10 bg-background-50/5 p-5 transition-colors hover:border-accent-400/50 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/15 md:h-12 md:w-12">
                <i className={`${point.icon} text-xl text-accent-300 md:text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50 md:text-xl">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-50/70">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded-lg border border-primary-400/30 bg-primary-500/10 p-5 md:mt-8 md:flex-row md:items-center md:justify-between md:p-7">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-flight-takeoff-line text-xl text-background-50"></i>
            </span>
            <div>
              <p className="font-heading text-base font-bold text-background-50 md:text-lg">
                出差、旅行前，先缓存好要看的几集
              </p>
              <p className="mt-1 text-sm leading-relaxed text-background-50/70">
                出门前把剧集缓存完成，就不用担心路上网络差或流量不够，打开就能直接看。
              </p>
            </div>
          </div>
          <a
            href="#storage"
            className="inline-flex flex-shrink-0 items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
          >
            <i className="ri-database-2-line text-base"></i>
            <span className="whitespace-nowrap">了解存储与画质</span>
          </a>
        </div>
      </div>
    </section>
  );
}